import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"

export type SpecialPricingDataType = {
    id: string
    name: string
    total: number
}

export type TaxObjectDataType = {
    rowNumber: string
    name: string
    percentage: string
    total: number
}

export type TipObjectDataType = {
    id: string
    name: string
    amountTip: number
}

export type NetCollectedBreakdownDataType = {
    grossRevenue: number
    refundsTotal: number
    voidsTotal: number
    specialPricings: SpecialPricingDataType[]
    netRevenue: number
    taxes: TaxObjectDataType[]
    tipsTotal: number
    historicalRefunds: number
    futureRefunds: number
    netCollected: number
    losses: number
    forfeits: number
    gratuityTotal: number
    cardSurcharge: number
    cashDiscount: number
    serviceFee: number
    tipsAndGratuityTotal: number
    tips: TipObjectDataType[]
}

export type NetCollectedByEmployeeDataType = {
    id: Maybe<string>
    firstName: Maybe<string>
    surname: Maybe<string>
    cashTotal: number
    cardTotal: number
    externalTotal: number
    total: number
    redemptionTotal: number
    children: NetCollectedByEmployeeDataType[]
}

export type NetCollectedByEmployeeDetailDataType = {
    id: string
    firstName: Maybe<string>
    surname: Maybe<string>
    grossRevenueTotal: number
    voidsTotal: number
    refundsTotal: number
    specialPricingsTotal: number
    lossesTotal: number
    forfeitedTotal: number
    taxTotal: number
    tipsTotal: number
    total: number
    children: NetCollectedByEmployeeDetailDataType[]
}

export type NetCollectedByPaymentTypeDataType = {
    paymentType: Maybe<ReportsPaymentType>
    grossRevenue: number
    refundsTotal: number
    cardSurcharge: number
    cashDiscount: number
    serviceFee: number
    voidsTotal: number
    netRevenue: number
    tipsTotal: number
    historicalRefunds: number
    futureRefunds: number
    netCollected: number
    losses: number
    forfeits: number
    gratuityTotal: number
    tipsAndGratuityTotal: number
    taxes: TaxObjectDataType[]
    specialPricings: SpecialPricingDataType[]
    tips: TipObjectDataType[]
    children: NetCollectedByPaymentTypeDataType[]
}

export type NetRevenueByCategoryDataType = {
    id: string
    name: string
    quantity: number
    quantityPercentage: number
    revenue: number
    revenuePercentage: number
    children: NetRevenueByCategoryDataType[]
    unit: Maybe<string>
    unitQuantity: Maybe<number>
}

export type NetRevenueByAssignmentDataType = {
    id: string
    name: string
    quantity: number
    quantityPercentage: number
    revenue: number
    revenuePercentage: number
    children: NetRevenueByAssignmentDataType[]
}

export type NetCollectedBySourceDataType = {
    id: string
    name: string
    count: number
    countPercentage: number
    total: number
    totalPercentage: number
    children: NetCollectedBySourceDataType[]
}

export type TransactionsByPaymentTypeDataType = {
    name: string
    creditsCount: number
    debitsCount: number
    netCount: number
    percentage: number
    total: number
    children: TransactionsByPaymentTypeDataType[]
}

export const SummaryGraphTypeEnum = {
    Daily: "daily",
    Hourly: "hourly",
}

export type SummaryGraphType = (typeof SummaryGraphTypeEnum)[keyof typeof SummaryGraphTypeEnum]

export type TrendingDataItem = {
    date: string
    netRevenueOpened: number
    netRevenueClosed: number
    orderCountOpened: number
}

export type TrendingDataItemProcessed = {
    date: string
    netRevenueOpened: number
    netRevenueClosed: number
    orderCountOpened: number
}

export type TrendingDataSums = {
    netRevenueOpened: number
    netRevenueClosed: number
    netRevenueProjected: number
}

export type BreakdownByHourItem = {
    hour: number
    revenueReceived: number
    revenueReceivable: number
    createdOrders: number
    openOrders: number
}

export enum ReportsPaymentType {
    Cash = "Cash",
    Card = "Card",
    External = "External",
    Redemption = "Loyalty Rewards",
    CardProgram = "Card Program",
}
